<template>
  <div class="player">
    <div class="tracklist">
      <div class="columns">
        <div class="column centering">
          <img class="track" v-on:click="playTrack(0)" src="../../assets/Main/TrackList/track1.png">
          <img class="track" v-on:click="playTrack(1)" src="../../assets/Main/TrackList/track2.png">
          <img class="track" v-on:click="playTrack(2)" src="../../assets/Main/TrackList/track3.png">
          <img class="track" v-on:click="playTrack(3)" src="../../assets/Main/TrackList/track4.png">
        </div>
        <div class="column centering" style="display: flex; justify-content: center; align-items: center;">
          <div>
            <img class="track" v-on:click="playTrack(4)" src="../../assets/Main/TrackList/track5.png">
            <img class="track" v-on:click="playTrack(5)" src="../../assets/Main/TrackList/track6.png">
            <img class="track" v-on:click="playTrack(6)" src="../../assets/Main/TrackList/track7.png">
          </div>
        </div>
        <div class="column centering">
          <img class="track" v-on:click="playTrack(7)" src="../../assets/Main/TrackList/track8.png">
          <img class="track" v-on:click="playTrack(8)" src="../../assets/Main/TrackList/track9.png">
          <img class="track" v-on:click="playTrack(9)" src="../../assets/Main/TrackList/track10.png">
          <img class="track" v-on:click="playTrack(10)" src="../../assets/Main/TrackList/track11.png">
        </div>
      </div>
    </div>
    <div class="soundcloud">
      <iframe ref=soundcloud width="100%" height="166" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/478099737%3Fsecret_token%3Ds-1kzrF&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: "Player",
  data() {
    return {
      scWidget: null,
      seekPoint: [
        0,
        37500,
        75000,
        112500,
        150000,
        187500,
        223000,
        260000,
        297500,
        335000,
        372500,
        1000000
      ]
    };
  },
  methods: {
    onDisplayed() {},
    playTrack(trackIdx) {
      this.scWidget.seekTo(this.seekPoint[trackIdx]);
      this.scWidget.play();
    }
  },
  mounted: function() {
    const $ = require("jquery");
    $.ajax({
      url: "https://w.soundcloud.com/player/api.js",
      dataType: "script",
      async: true,
      success: () => {
        const seekPoint = this.seekPoint;
        this.scWidget = SC.Widget(this.$refs.soundcloud);
        let widget = this.scWidget;
        widget.bind(SC.Widget.Events.PLAY_PROGRESS, eventData => {
          let currentSeekPos = eventData.currentPosition;
          const tracks = this.$el.querySelectorAll(".track");
          let currentTrackIdx = -1;
          for (let i = 0; i < seekPoint.length; i++) {
            if (seekPoint[i] > currentSeekPos) {
              currentTrackIdx = i - 1;
              break;
            }
          }
          for (let i = 0; i < tracks.length; i++) {
            if (i == currentTrackIdx) {
              if (currentSeekPos > 100) {
                tracks[i].classList.add("playing");
              }
            } else {
              tracks[i].classList.remove("playing");
            }
          }
        });
        widget.bind(SC.Widget.Events.FINISH, eventData => {
          for (let i = 0; i < tracks.length; i++) {
            tracks[i].classList.remove("playing");
          }
        });
      }
    });
  }
};
</script>

<style lang="scss" scoped>
.tracklist {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.soundcloud {
  filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.4));
}

.centering {
  padding-top: 0;
  padding-bottom: 0;
  text-align: center;
}

.track {
  pointer-events: auto;
  transition: 0.3s ease;
  transform: scale(0.9, 0.9);
  filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.4));
  &:hover {
    cursor: pointer;
    transform: scale(1, 1);
  }
}

.playing {
  transform: scale(1, 1);
  animation: vertical 1s ease-in-out infinite alternate;
}

@keyframes vertical {
  0% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(2px);
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Parts/Player.vue